import {
  FETCH_BRAND_LEADS_EXPORTS_START,
  FETCH_BRAND_LEADS_EXPORTS_SUCCESS,
  FETCH_BRAND_LEADS_EXPORTS_FAILURE,
  CREATE_BRAND_LEADS_EXPORT_START,
  CREATE_BRAND_LEADS_EXPORT_SUCCESS,
  CREATE_BRAND_LEADS_EXPORT_FAILURE,
  RESET_BRAND_LEADS_EXPORT_CREATE,
} from '../constants/brandLeadsExportsTypes'

const INITIAL = {
  list: { loading: false, success: null, data: [], errors: null },
  create: { loading: false, success: null, data: null, errors: null },
}

export default function reducer(state = INITIAL, action) {
  switch (action.type) {
    case FETCH_BRAND_LEADS_EXPORTS_START:
      return {
        ...state,
        list: { loading: true, success: null, data: state.list.data, errors: null },
      }
    case FETCH_BRAND_LEADS_EXPORTS_SUCCESS:
      return {
        ...state,
        list: { loading: false, success: true, data: action.data || [], errors: null },
      }
    case FETCH_BRAND_LEADS_EXPORTS_FAILURE:
      return {
        ...state,
        list: { loading: false, success: false, data: state.list.data, errors: action.errors },
      }

    case CREATE_BRAND_LEADS_EXPORT_START:
      return {
        ...state,
        create: { loading: true, success: null, data: null, errors: null },
      }
    case CREATE_BRAND_LEADS_EXPORT_SUCCESS:
      return {
        ...state,
        create: { loading: false, success: true, data: action.data, errors: null },
        list: { ...state.list, data: [action.data, ...state.list.data] },
      }
    case CREATE_BRAND_LEADS_EXPORT_FAILURE:
      return {
        ...state,
        create: { loading: false, success: false, data: null, errors: action.errors },
      }
    case RESET_BRAND_LEADS_EXPORT_CREATE:
      return { ...state, create: INITIAL.create }

    default:
      return state
  }
}
